import styled from 'styled-components';

export const StyledDialogContainer = styled.div`
  min-height: 150px;
  display: flex;
  gap: 24px;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  @media (max-width: 768px) {
    padding: 15px 30px;
  }
`;
export const StyledDialogIcon = styled.img`
  height: 72px
`;
export const StyledTitle = styled.span`
  font-weight: 600;
  line-height: 24px;
  text-align: center;
  color: black;
  font-size: 16px;
`;
export const StyledDescription = styled.span`
  font-weight: 500;
  line-height: 24px;
  text-align: center;
  color: dimgrey;
  font-size: 14px;
`;
